/**
 * Countries + international dial codes, for the form's phone field.
 *
 * The point of this is not the dropdown, it is the phone number. A lead who
 * types "9876543210" and a lead who types "+91 98765 43210" are the same person,
 * but only one of them can be messaged on WhatsApp, matched to a Meta CAPI
 * event, or deduped against an existing record. Making the country explicit at
 * capture time is the only place that is cheap to fix - everything downstream is
 * guesswork.
 *
 * Stored as one string rather than 240 object literals: it is a static table,
 * and this keeps the file readable and the bundle small. ISO2,Name,DialCode.
 */
const RAW = [
  'AF,Afghanistan,93', 'AL,Albania,355', 'DZ,Algeria,213', 'AS,American Samoa,1684',
  'AD,Andorra,376', 'AO,Angola,244', 'AI,Anguilla,1264', 'AG,Antigua and Barbuda,1268',
  'AR,Argentina,54', 'AM,Armenia,374', 'AW,Aruba,297', 'AU,Australia,61', 'AT,Austria,43',
  'AZ,Azerbaijan,994', 'BS,Bahamas,1242', 'BH,Bahrain,973', 'BD,Bangladesh,880',
  'BB,Barbados,1246', 'BY,Belarus,375', 'BE,Belgium,32', 'BZ,Belize,501', 'BJ,Benin,229',
  'BM,Bermuda,1441', 'BT,Bhutan,975', 'BO,Bolivia,591', 'BA,Bosnia and Herzegovina,387',
  'BW,Botswana,267', 'BR,Brazil,55', 'BN,Brunei,673', 'BG,Bulgaria,359', 'BF,Burkina Faso,226',
  'BI,Burundi,257', 'KH,Cambodia,855', 'CM,Cameroon,237', 'CA,Canada,1', 'CV,Cape Verde,238',
  'KY,Cayman Islands,1345', 'CF,Central African Republic,236', 'TD,Chad,235', 'CL,Chile,56',
  'CN,China,86', 'CO,Colombia,57', 'KM,Comoros,269', 'CG,Congo,242',
  'CD,Congo (DRC),243', 'CK,Cook Islands,682', 'CR,Costa Rica,506', 'CI,Cote d Ivoire,225',
  'HR,Croatia,385', 'CU,Cuba,53', 'CW,Curacao,599', 'CY,Cyprus,357', 'CZ,Czechia,420',
  'DK,Denmark,45', 'DJ,Djibouti,253', 'DM,Dominica,1767', 'DO,Dominican Republic,1809',
  'EC,Ecuador,593', 'EG,Egypt,20', 'SV,El Salvador,503', 'GQ,Equatorial Guinea,240',
  'ER,Eritrea,291', 'EE,Estonia,372', 'SZ,Eswatini,268', 'ET,Ethiopia,251', 'FJ,Fiji,679',
  'FI,Finland,358', 'FR,France,33', 'GF,French Guiana,594', 'PF,French Polynesia,689',
  'GA,Gabon,241', 'GM,Gambia,220', 'GE,Georgia,995', 'DE,Germany,49', 'GH,Ghana,233',
  'GI,Gibraltar,350', 'GR,Greece,30', 'GL,Greenland,299', 'GD,Grenada,1473',
  'GP,Guadeloupe,590', 'GU,Guam,1671', 'GT,Guatemala,502', 'GG,Guernsey,44', 'GN,Guinea,224',
  'GW,Guinea-Bissau,245', 'GY,Guyana,592', 'HT,Haiti,509', 'HN,Honduras,504',
  'HK,Hong Kong,852', 'HU,Hungary,36', 'IS,Iceland,354', 'IN,India,91', 'ID,Indonesia,62',
  'IR,Iran,98', 'IQ,Iraq,964', 'IE,Ireland,353', 'IM,Isle of Man,44', 'IL,Israel,972',
  'IT,Italy,39', 'JM,Jamaica,1876', 'JP,Japan,81', 'JE,Jersey,44', 'JO,Jordan,962',
  'KZ,Kazakhstan,7', 'KE,Kenya,254', 'KI,Kiribati,686', 'XK,Kosovo,383', 'KW,Kuwait,965',
  'KG,Kyrgyzstan,996', 'LA,Laos,856', 'LV,Latvia,371', 'LB,Lebanon,961', 'LS,Lesotho,266',
  'LR,Liberia,231', 'LY,Libya,218', 'LI,Liechtenstein,423', 'LT,Lithuania,370',
  'LU,Luxembourg,352', 'MO,Macao,853', 'MG,Madagascar,261', 'MW,Malawi,265',
  'MY,Malaysia,60', 'MV,Maldives,960', 'ML,Mali,223', 'MT,Malta,356',
  'MH,Marshall Islands,692', 'MQ,Martinique,596', 'MR,Mauritania,222', 'MU,Mauritius,230',
  'MX,Mexico,52', 'FM,Micronesia,691', 'MD,Moldova,373', 'MC,Monaco,377', 'MN,Mongolia,976',
  'ME,Montenegro,382', 'MS,Montserrat,1664', 'MA,Morocco,212', 'MZ,Mozambique,258',
  'MM,Myanmar,95', 'NA,Namibia,264', 'NR,Nauru,674', 'NP,Nepal,977', 'NL,Netherlands,31',
  'NC,New Caledonia,687', 'NZ,New Zealand,64', 'NI,Nicaragua,505', 'NE,Niger,227',
  'NG,Nigeria,234', 'KP,North Korea,850', 'MK,North Macedonia,389', 'NO,Norway,47',
  'OM,Oman,968', 'PK,Pakistan,92', 'PW,Palau,680', 'PS,Palestine,970', 'PA,Panama,507',
  'PG,Papua New Guinea,675', 'PY,Paraguay,595', 'PE,Peru,51', 'PH,Philippines,63',
  'PL,Poland,48', 'PT,Portugal,351', 'PR,Puerto Rico,1787', 'QA,Qatar,974',
  'RE,Reunion,262', 'RO,Romania,40', 'RU,Russia,7', 'RW,Rwanda,250',
  'KN,Saint Kitts and Nevis,1869', 'LC,Saint Lucia,1758',
  'VC,Saint Vincent and the Grenadines,1784', 'WS,Samoa,685', 'SM,San Marino,378',
  'ST,Sao Tome and Principe,239', 'SA,Saudi Arabia,966', 'SN,Senegal,221', 'RS,Serbia,381',
  'SC,Seychelles,248', 'SL,Sierra Leone,232', 'SG,Singapore,65', 'SK,Slovakia,421',
  'SI,Slovenia,386', 'SB,Solomon Islands,677', 'SO,Somalia,252', 'ZA,South Africa,27',
  'KR,South Korea,82', 'SS,South Sudan,211', 'ES,Spain,34', 'LK,Sri Lanka,94',
  'SD,Sudan,249', 'SR,Suriname,597', 'SE,Sweden,46', 'CH,Switzerland,41', 'SY,Syria,963',
  'TW,Taiwan,886', 'TJ,Tajikistan,992', 'TZ,Tanzania,255', 'TH,Thailand,66',
  'TL,Timor-Leste,670', 'TG,Togo,228', 'TO,Tonga,676', 'TT,Trinidad and Tobago,1868',
  'TN,Tunisia,216', 'TR,Turkiye,90', 'TM,Turkmenistan,993',
  'TC,Turks and Caicos Islands,1649', 'TV,Tuvalu,688', 'UG,Uganda,256', 'UA,Ukraine,380',
  'AE,United Arab Emirates,971', 'GB,United Kingdom,44', 'US,United States,1',
  'UY,Uruguay,598', 'UZ,Uzbekistan,998', 'VU,Vanuatu,678', 'VA,Vatican City,39',
  'VE,Venezuela,58', 'VN,Vietnam,84', 'VG,Virgin Islands (British),1284',
  'VI,Virgin Islands (US),1340', 'YE,Yemen,967', 'ZM,Zambia,260', 'ZW,Zimbabwe,263',
];

export const COUNTRIES = RAW.map((row) => {
  const [iso, name, dial] = row.split(',');
  return { iso, name, dial };
}).sort((a, b) => a.name.localeCompare(b.name));

const BY_ISO = new Map(COUNTRIES.map((c) => [c.iso, c]));
const BY_NAME = new Map(COUNTRIES.map((c) => [c.name.toLowerCase(), c]));

// The flag is derived from the ISO code (regional indicator symbols) rather than
// stored, so there is no second list to keep in sync.
export function flagOf(iso) {
  const s = String(iso || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(s)) return '';
  return s.replace(/./g, (ch) => String.fromCodePoint(127397 + ch.charCodeAt(0)));
}

export const countryByIso = (iso) => BY_ISO.get(String(iso || '').toUpperCase()) || null;
export const countryByName = (name) => BY_NAME.get(String(name || '').trim().toLowerCase()) || null;
// Accepts either, because a country FIELD stores the name while the phone
// selector stores the ISO code.
export const resolveCountry = (v) => countryByIso(v) || countryByName(v);

export const labelOf = (c) => (c ? `${flagOf(c.iso)}  ${c.name}  +${c.dial}` : '');

// Best guess at the visitor's country, so the phone field is usually already
// right. The browser never tells us directly, so: the form's own default, then
// the locale region (en-IN -> IN), then India.
// Which country the phone field starts on. Callers pass the best hint they
// have, in this order: the form's own Default country, then the workspace's
// country (derived from its timezone), and only then does this fall through to
// the visitor's browser locale. That order matters - en-GB is a common browser
// locale in India, so locale-first handed Indian visitors +44 on an Indian
// company's form.
export function guessCountryIso(fallback) {
  const fromFallback = countryByIso(fallback);
  if (fromFallback) return fromFallback.iso;
  try {
    const locales = [navigator.language, ...(navigator.languages || [])];
    for (const loc of locales) {
      const region = String(loc || '').split('-')[1];
      if (region && countryByIso(region)) return region.toUpperCase();
    }
  } catch (_e) { /* no navigator (SSR / tests) */ }
  return 'IN';
}

// Split a typed phone into { iso, national }. A number that already carries a
// country code keeps it - re-prefixing "+919876543210" would produce +91919...,
// which is the exact bug this whole field exists to prevent. Longest dial code
// wins so +1876 (Jamaica) is not read as +1 (US).
// Several countries can share one dial code (+44 is the UK, Guernsey, Jersey and
// the Isle of Man; +1 is the US and Canada). A number alone cannot tell them
// apart, so each shared code names the country to assume - otherwise "+44…"
// resolved to Guernsey purely because G sorts before U.
const PRIMARY_FOR_DIAL = { 1: 'US', 7: 'RU', 39: 'IT', 44: 'GB', 262: 'RE', 590: 'GP', 599: 'CW' };
const BY_DIAL_DESC = [...COUNTRIES]
  .filter((c) => !PRIMARY_FOR_DIAL[c.dial] || PRIMARY_FOR_DIAL[c.dial] === c.iso)
  .sort((a, b) => b.dial.length - a.dial.length);
export function splitPhone(raw, currentIso) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return { iso: currentIso, national: '' };
  const looksInternational = String(raw || '').trim().startsWith('+');
  if (looksInternational) {
    for (const c of BY_DIAL_DESC) {
      if (digits.startsWith(c.dial) && digits.length > c.dial.length) {
        return { iso: c.iso, national: digits.slice(c.dial.length) };
      }
    }
  }
  // No '+': the digits are the national number. But a paste of "919876543210"
  // where the current country is India is the same number typed with its code,
  // so a leading dial code is stripped - CAREFULLY.
  //
  // The old test was "anything with 7+ digits left over", which ate real
  // numbers: an Indian mobile beginning 91 (9160436269 - a perfectly ordinary
  // number) had its first two digits read as the country code and became the
  // 8-digit 60436269. The visitor watched two digits vanish as they typed and
  // had no way to stop it.
  //
  // A leading dial code is only a country code when the number does NOT
  // already read as a valid national number on its own. 9160436269 is exactly
  // 10 digits, which is a complete Indian mobile, so it is left alone;
  // 919160436269 is 12, which is not, and stripping leaves a valid 10 - so
  // that one is a country code and gets stripped. Where both readings are
  // valid, the digits the visitor actually typed win.
  const cur = countryByIso(currentIso);
  if (cur && digits.startsWith(cur.dial)) {
    const [min, max] = NSN[cur.iso] || NSN_FALLBACK;
    const typed = digits.length;
    const stripped = typed - cur.dial.length;
    const typedIsWhole = typed >= min && typed <= max;
    const strippedIsWhole = stripped >= min && stripped <= max;
    if (!typedIsWhole && strippedIsWhole) {
      return { iso: cur.iso, national: digits.slice(cur.dial.length) };
    }
  }
  return { iso: currentIso, national: digits };
}

// What we actually submit: E.164, no spaces. This is the format WhatsApp, Meta
// CAPI and every deduplication path want.
export function toE164(iso, national) {
  const c = countryByIso(iso);
  const digits = String(national || '').replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return '';
  return c ? `+${c.dial}${digits}` : `+${digits}`;
}

// National-number length AFTER the dial code, as [min, max]. Mirrors the
// server's phoneRules.js - the API is the floor, this is the friendly version
// that catches "one digit too many" before the visitor hits submit. Countries
// not listed fall back to 6-12 digits.
const NSN = {
  IN: [10, 10], US: [10, 10], CA: [10, 10], GB: [9, 10], IE: [7, 9], AU: [9, 9],
  NZ: [8, 10], SG: [8, 8], HK: [8, 8], MO: [8, 8], MY: [8, 10], PH: [8, 10],
  ID: [8, 12], TH: [8, 9], VN: [9, 10], JP: [9, 10], KR: [8, 11], CN: [10, 12],
  TW: [8, 9], PK: [10, 10], BD: [8, 10], LK: [9, 9], NP: [8, 10], AE: [8, 9],
  SA: [8, 9], QA: [8, 8], KW: [8, 8], BH: [8, 8], OM: [8, 8], JO: [8, 9],
  IL: [8, 9], LB: [7, 8], IQ: [10, 10], IR: [10, 10], TR: [10, 10], RU: [10, 10],
  KZ: [10, 10], UA: [9, 9], DE: [7, 11], FR: [9, 9], IT: [8, 11], ES: [9, 9],
  PT: [9, 9], NL: [9, 9], BE: [8, 9], CH: [9, 9], SE: [7, 9], NO: [8, 8],
  DK: [8, 8], PL: [9, 9], CZ: [9, 9], SK: [9, 9], HU: [8, 9], RO: [9, 9],
  BG: [8, 9], GR: [10, 10], ZA: [9, 9], NG: [8, 10], KE: [9, 9], GH: [9, 9],
  TZ: [9, 9], UG: [9, 9], EG: [8, 10], MA: [9, 9], DZ: [8, 9], TN: [8, 8],
  ET: [9, 9], ZW: [9, 9], ZM: [9, 9], RW: [9, 9], BR: [10, 11], MX: [10, 10],
  AR: [10, 10], CL: [9, 9], CO: [10, 10], PE: [9, 9], VE: [10, 10], EC: [8, 9],
  UY: [8, 8], PY: [9, 9], BO: [8, 8],
};
const NSN_FALLBACK = [6, 12];

// Why the submitted phone cannot be right, or null when it can. Judged on the
// E.164 value the form actually sends, so what passes here passes the API too.
export function phoneProblem(e164) {
  const s = String(e164 || '').trim();
  const digits = s.replace(/\D/g, '');
  if (!digits) return 'Please add your phone number.';
  if (!s.startsWith('+')) return 'Please pick your country code.';
  if (digits.length > 15) return 'That phone number is too long.';
  const parsed = splitPhone(s, null);
  const c = countryByIso(parsed.iso);
  if (!c) return 'That country calling code is not recognised.';
  const [min, max] = NSN[c.iso] || NSN_FALLBACK;
  const n = parsed.national.length;
  if (n < min || n > max) {
    const want = min === max ? `${min} digits` : `${min}-${max} digits`;
    return `A phone number in ${c.name} (+${c.dial}) has ${want} after the code - you entered ${n}.`;
  }
  return null;
}

// The form's own country question, if the tenant added one. When present the
// phone field follows it, and answering the phone's picker back-fills it - the
// visitor should never state their country twice.
export function countryFieldOf(formConfig) {
  const f = (formConfig?.fields || []).find((x) => x && x.type === 'country');
  return f ? f.id : null;
}
